import React, { useRef } from 'react'
import styled from 'styled-components'
import { motion, useAnimation } from 'framer-motion'
import { useInView } from 'react-intersection-observer';
import { useEffect } from 'react'
import { v4 as uuid } from 'uuid'

import { FiUserPlus, FiUnlock, FiShoppingCart, FiCheckCircle } from 'react-icons/fi'

import { MainTextHolder } from './Utils'

export default function How() {
  const controls = useAnimation()
  const { ref, inView } = useInView();
  const animated = useRef<boolean>(false)

  useEffect(() => {
    if (inView && !animated.current) {
      controls.start(i => ({
        opacity: 1,
        y: 0,
        transition: { delay: i * 0.3, duration: 0.8 },
      }))
      animated.current = true
    } else {
      controls.start({
        opacity: 1,
        y: 0,
        transition: {
          delay: 0,
          duration: 0
        }
      })
    }
  }, [controls, inView])

  return (
    <div id="shop">
      <MainTextHolder>
        <h3>Så här handlar du</h3>
        <HowItemHolder ref={ref}>
          <HowItem
            custom={0}
            animate={controls}
            initial={{ opacity: 0, y: 20 }}
            key={uuid()}
          >
            <ListItem
              title="Skapa en profil"
              text="Fyll i dina uppgifter och spara"
              icon={<FiUserPlus size="80px" />}
            />
          </HowItem>
          <HowItem
            custom={1.75}
            animate={controls}
            initial={{ opacity: 0, y: 20 }}
            key={uuid()}
          >
            <ListItem
              title="Lås upp din butik"
              text="Gå till fliken ”Min butik” och tryck på ”Öppna butiken”. Tänk på att du måste vara nära dörren för att kunna öppna."
              icon={<FiUnlock size="80px" />}
            />
          </HowItem>
          <HowItem
            custom={3.5}
            animate={controls}
            initial={{ opacity: 0, y: 20 }}
            key={uuid()}
          >
            <ListItem
              title="Handla"
              text="Ta en korg, välj dina varor, scanna dina varor vid kassan, den är utformad med plats att ställa korgen och en påshängare på andra sidan för att underlätta."
              icon={<FiShoppingCart size="80px" />}
            />
          </HowItem>
          <HowItem
            custom={5.25}
            animate={controls}
            initial={{ opacity: 0, y: 20 }}
            key={uuid()}
          >
            <ListItem
              title="Klart!"
              text="När alla varor är scannade väljer du ”betala med kort” på kassaskärmen. När kvittot är utskrivet är det klart. Använd knappen vid dörren för att öppna."
              icon={<FiCheckCircle size="80px" />}
            />
          </HowItem>
        </HowItemHolder>
      </MainTextHolder>
    </div>
  )
}

const ListItem = ({
  title,
  text,
  icon,
}: {
  title: string
  text: string
  icon: any
}) => {
  return (
    <ItemHolder>
      {icon}
      <div>
        <strong>{title}</strong>
        <p>{text}</p>
      </div>
    </ItemHolder>
  )
}

const HowItemHolder = styled(motion.ul)`
  margin-top: 80px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: flex-start;
  justify-content: center;
  align-items: flex-start;
`

const HowItem = styled(motion.li)`
  font-family: Glasgow;
  font-weight: 500;
  color: #fff;
  text-align: center;
  opacity: 0;
  text-align: left;
  width: 100%;

  @media (min-width: 769px) {
    width: 50%;
  }
`

const ItemHolder = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0 auto;
  width: 100%;
  margin-bottom: 40px;

  svg {
    margin-right: 20px;

    @media (min-width: 769px) {
      margin-right: 40px;
    }
  }

  strong {
    font-size: 22px;
    line-height: 28px;
    font-family: Glasgow;
    font-weight: 500;

    @media (min-width: 769px) {
      font-size: 28px;
      line-height: 32px;
    }
  }

  p {
    font-size: 18px;
    line-height: 24px;
    margin: 8px 0;

    @media (min-width: 769px) {
      font-size: 22px;
      line-height: 28px;
    }
  }

  > div {
    width: 100%;
  }
`
